(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.sdk'

  require('angular')
    .module(MODULE_NAME, [
      require('./sdk-config'),
      require('./sdk')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/index.js